import {combine, restore} from 'effector';

import {
    clearProductsGridCache,
    fetchProductsGrid,
    fetchProductsNames,
    fetchStorageLocations,
    loadGridCsv,
} from 'api';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {SimplePaginationContent} from 'types/api';
import {ProductsGridRawRow} from 'types/products-grid';

const domain = rootDomain.createDomain('ProductsGridTableDomain');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchProductsGrid,
});

export const clearDataCacheFx = domain.createEffect({
    name: 'clearDataCacheFx',
    handler: clearProductsGridCache,
});

export const fetchCsv = domain.createEffect({
    name: 'fetchProductsCsv',
    handler: loadGridCsv,
});

export const fetchProductsNamesFx = domain.createEffect({
    name: 'fetchProductsNamesFx',
    handler: fetchProductsNames,
});

export const fetchStorageLocationsFx = domain.createEffect({
    name: 'fetchStorageLocationsFx',
    handler: fetchStorageLocations,
});

export const {
    filters$,
    filtersChanged,
    filtersReset,
    defaultFilters,
    sortings$,
    sortingsChanged,
    sortingsReset,
    defaultSortings,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    Gate,
    tableStateChanged,
    tableStateCacheChanged,
    stateReset,
} = createGridTableModel({domain});

export const data$ = domain.createStore<SimplePaginationContent<ProductsGridRawRow> | null>(null);

export const codesFileChanged = domain.createEvent<File | null>('codesFileChanged');
export const codesFile$ = restore(codesFileChanged, null);

export const searchChanged = domain.createEvent<string>();
export const search$ = domain.createStore<string>('').on(searchChanged, (_, value) => value);

export const gridCacheChanged = domain.createEvent<{pageNumber: number; token: string | null}>();
export const gridCacheReset = domain.createEvent();
export const gridTokensCache$ = domain.createStore<Record<number, string | null>>({0: null});

export const productsNames$ = domain.createStore<{id: string; value: string; label: string}[]>([]);
export const storageLocations$ = domain.createStore<{id: string; value: string; label: string}[]>(
    [],
);

export const initWithAffixingFilters = domain.createEvent();

export const tableState$ = combine({
    data: data$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    filters: filters$,
    sortings: sortings$,
    codesFile: codesFile$,
    search: search$,
    gridTokensCache: gridTokensCache$,
    isLoading: fetchDataFx.pending,
    exportPending: fetchCsv.pending,
});
